import firebase from 'firebase/compat/app';
import { firebaseConfigCalendario } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import Swal from 'sweetalert';

const firebaseCalendario = firebase.initializeApp(firebaseConfigCalendario, 'Calendario Letícia');
const db = firebaseCalendario.firestore();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');
const logado = localStorage.getItem('logado') ? localStorage.getItem('logado').toLowerCase() : null;


const lerCalendario = async () => {
    try {
        const mesesSnapshot = await db.collection(ANO)
            .doc('calendario')
            .collection('meses')
            .get();

        const meses = {};
        mesesSnapshot.forEach((doc) => {
            const mes = doc.id;
            const dias = doc.data().json || {};
            meses[mes] = dias;
        });

        return meses;
    } catch (error) {
        console.error('Erro ao obter documentos: ', error);
        throw error; // Re-throw the error to be caught by the caller
    }
};


const lerMesCalendario = async (mes) => {
    try {
        const docMes = await db.collection(ANO)
            .doc('calendario')
            .collection('meses')
            .doc(mes).get();

        if (docMes.exists) {
            const dias = docMes.data().json || {};
            return dias;
        }

    } catch (error) {
        console.error('Erro ao obter documentos: ', error);
        throw error; // Re-throw the error to be caught by the caller
    }
};



const enviarEventoCalendario = async (nomeEvento, dataEvento) => {
    if (!nomeEvento || !dataEvento) {
        Swal({
            title: 'Digite o nome do evento e a data!',
            icon: 'error',
        });
        return false;
    }
    try {
        const mes = dataEvento.slice(5, 6) === '0' ? dataEvento.slice(6, 7) : dataEvento.slice(5, 7);
        const dia = dataEvento.slice(8, 9) === '0' ? dataEvento.slice(9, 10) : dataEvento.slice(8, 10);
        
        const docEvento = await db.collection(ANO)
        .doc('calendario')
        .collection('meses')
        .doc(mes).get();

        if (docEvento.exists) {
            var json = docEvento.data().json || [];
            var array = json[dia] || [];
            array.push(nomeEvento);
            json[dia] = array;
            await db.collection(ANO)
            .doc('calendario')
            .collection('meses')
            .doc(mes).update({
                json: json,
            }).then((res) => {
                Swal({
                    title: 'Calendário editado com sucesso!',
                    icon: 'success',
                });
                return true;
            });
        } else {
            var json = '';
            if (mes === 1 || mes === 3 || mes === 5 || mes === 7 || mes === 8 || mes === 10 || mes === 12) {
                json = {
                    1: [],
                    2: [],
                    3: [],
                    4: [],
                    5: [],
                    6: [],
                    7: [],
                    8: [],
                    9: [],
                    10: [],
                    11: [],
                    12: [],
                    13: [],
                    14: [],
                    15: [],
                    16: [],
                    17: [],
                    18: [],
                    19: [],
                    20: [],
                    21: [],
                    22: [],
                    23: [],
                    24: [],
                    25: [],
                    26: [],
                    27: [],
                    28: [],
                    29: [],
                    30: [],
                    31: [],
                };
            } else {
                json = {
                    1: [],
                    2: [],
                    3: [],
                    4: [],
                    5: [],
                    6: [],
                    7: [],
                    8: [],
                    9: [],
                    10: [],
                    11: [],
                    12: [],
                    13: [],
                    14: [],
                    15: [],
                    16: [],
                    17: [],
                    18: [],
                    19: [],
                    20: [],
                    21: [],
                    22: [],
                    23: [],
                    24: [],
                    25: [],
                    26: [],
                    27: [],
                    28: [],
                    29: [],
                    30: [],
                };
            }
            var array = json[dia] || [];
            array.push(nomeEvento);
            json[dia] = array;
            await db.collection(ANO)
            .doc('calendario')
            .collection('meses')
            .doc(mes).set({
                json: json,
            }).then((res) => {
                Swal({
                    title: 'Calendário criado e editado com sucesso!',
                    icon: 'success',
                });
                return true;
            });
        }

        return true;
    } catch (error) {
        console.error('Erro ao obter documentos: ', error);
        throw error;
    }
};


const excluirEventoCalendario = async (nomeEvento, dia, mes) => {
    if (!nomeEvento || !dia || !mes) {
        Swal({
            title: 'Digite o nome do evento e as datas corretas!',
            icon: 'error',
        });
        return false;
    }
    try {
        Swal({
            title: `Você deseja excluir o evento "${nomeEvento}"?`,
            icon: 'warning',
            buttons: {
                confirm: 'Sim',
                cancel: 'Não'
            },
        }).then( async (resposta) => {
            if (resposta) {
                const docEvento = await db.collection(ANO)
                .doc('calendario')
                .collection('meses')
                .doc(mes).get();
    
                if (docEvento.exists) {
                    var json = docEvento.data().json || [];
                    var array = json[dia] || [];
                    let index = array.indexOf(nomeEvento);
                    if (index !== -1) {
                        array.splice(index, 1);
                    }
                    json[dia] = array;
                    await db.collection(ANO)
                    .doc('calendario')
                    .collection('meses')
                    .doc(mes).update({
                        json: json,
                    }).then((res) => {
                        Swal({
                            title: 'Calendário editado com sucesso!',
                            icon: 'success',
                        });
                        return true;
                    });
                }
            }
        });
        
        return true;

    } catch (error) {
        console.error('Erro ao obter documentos: ', error);
        throw error;
    }
};



export { lerCalendario, lerMesCalendario, enviarEventoCalendario, excluirEventoCalendario };